/**
 * Municipality page scripts.
 *
 * @module Municipality
 */

import CommonSubPage from './_CommonSubPage';

export default class Municipality extends CommonSubPage {}

  // INIT CITY VIDEO SLIDER 
  function initCityVideoSlider() {

    const $slider = $('.videoContent__container'),
          $prevArrow = $('.videoContent__btns_prev'),
          $nextArrow = $('.videoContent__btns_next');

    $slider.slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToScroll: 1,
      slidesToShow: 1,
      prevArrow: $prevArrow,
      nextArrow: $nextArrow,
    });

    $slider.on('init', function(){
      let btns = $slider.find('.slick-arrow').append('<span></span>');
    })

    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $('.videoContent__video')[currentSlide].pause();
      $('.videoContent__controls_play')[currentSlide].classList.remove('hided');
    })
  }

  initCityVideoSlider();

  
  function playVideoSlider() {
    let playBtn = $('.videoContent__controls_play');

    playBtn.click(function() {
      $(this).addClass('hided');
      $(this).parents('.videoContent__item').find('.videoContent__video').get(0).play();
      $(this).parents('.videoContent__item').find('.videoContent__btn-fullscreen').addClass('show');
    })
}

function pauseVideoSlider() {
  let videoBlock = $('.videoContent__video');

  videoBlock.click(function() {
    $(this).get(0).pause();
    $(this).parents('.videoContent__item').find('.videoContent__controls_play').removeClass('hided');
    $(this).parents('.videoContent__item').find('.videoContent__btn-fullscreen').removeClass('show');
  })
}

function fullScreenVideo() {
  let fullScreenBtn = $('.videoContent__btn-fullscreen');

  fullScreenBtn.click(function(e) {
    let elemVideo = e.target.parentElement.parentElement.querySelector('.videoContent__video');

    // console.log('click', elemVideo);
    if (elemVideo.requestFullscreen) {
      elemVideo.requestFullscreen();
    } else if (elemVideo.mozRequestFullScreen) { /* Firefox */
      elemVideo.mozRequestFullScreen();
    } else if (elemVideo.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
      elemVideo.webkitRequestFullscreen();
    } else if (elemVideo.msRequestFullscreen) { /* IE/Edge */
      elemVideo.msRequestFullscreen();
    }
  })
}

fullScreenVideo();

pauseVideoSlider();

playVideoSlider();


if($(window).width() < 767) {
  let videos = $('.videoContent__video');
  for (let i = 0; i < videos.length; i++) {
    $(videos[i]).attr('controls', true);
  }
  
  $('.videoContent__btn-fullscreen').hide();
}


// WEBPACK FOOTER //
// ./src/js/pages/municipality.js